export default "__VITE_ASSET__DyYV$4Uh__"